// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__JKWOC","notes":"Notes_notes__edo_3","note":"Notes_note__2Hmrh","markdown":"Notes_markdown__2eKB_"};